import React, { useState } from "react";
import { toast } from "sonner";
import { X } from "lucide-react";
import { api, AYLAR, extractErrorMessage } from "@/lib/api";

export const BulkPlanModal = ({ ids, onClose, onDone }) => {
  const now = new Date();
  const [f, setF] = useState({ taksit_sayisi: 3, baslangic_yil: now.getFullYear(), baslangic_ay: now.getMonth() + 1, kaynak: "maas" });
  const [busy, setBusy] = useState(false);
  const years = [0, 1, 2].map((k) => now.getFullYear() - 1 + k);
  const save = async () => {
    if (!window.confirm(`${ids.length} avansın mevcut taksit planı değiştirilecek. Devam?`)) return;
    setBusy(true);
    try {
      const r = await api.post("/advances/bulk-plan", { advance_ids: ids, ...f, taksit_sayisi: Number(f.taksit_sayisi) });
      toast.success(`${r.data.updated} avansın planı güncellendi`);
      onDone();
    } catch (e) { toast.error(extractErrorMessage(e, "Uygulanamadı")); } finally { setBusy(false); }
  };
  const inp = "w-full px-3 py-2 border border-slate-200 rounded-lg text-sm";
  return (
    <div className="fixed inset-0 z-50 bg-slate-900/60 backdrop-blur-sm grid place-items-center p-4" data-testid="bulk-plan-modal">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md">
        <div className="p-4 border-b flex items-center justify-between">
          <h3 className="font-display font-bold">Toplu Taksit Planı · {ids.length} avans</h3>
          <button onClick={onClose} data-testid="bulk-plan-close" className="w-8 h-8 rounded-lg hover:bg-slate-100 grid place-items-center"><X size={16} /></button>
        </div>
        <div className="p-4 space-y-3">
          <p className="text-xs text-slate-600">Her avans kendi tutarına göre eşit bölünür, tam liraya yuvarlanır, kalan son aya yazılır.</p>
          <div className="grid grid-cols-3 gap-2">
            <label className="text-xs font-semibold text-slate-600">Taksit
              <input type="number" min="1" max="120" value={f.taksit_sayisi} onChange={(e) => setF({ ...f, taksit_sayisi: e.target.value })} className={inp} data-testid="bulk-plan-taksit" />
            </label>
            <label className="text-xs font-semibold text-slate-600">Başlangıç Ayı
              <select value={f.baslangic_ay} onChange={(e) => setF({ ...f, baslangic_ay: Number(e.target.value) })} className={inp} data-testid="bulk-plan-ay">
                {AYLAR.map((m) => <option key={m.v} value={m.v}>{m.n}</option>)}
              </select>
            </label>
            <label className="text-xs font-semibold text-slate-600">Yıl
              <select value={f.baslangic_yil} onChange={(e) => setF({ ...f, baslangic_yil: Number(e.target.value) })} className={inp} data-testid="bulk-plan-yil">
                {years.map((y) => <option key={y} value={y}>{y}</option>)}
              </select>
            </label>
          </div>
          <div className="flex gap-2">
            {[["maas", "Maaştan kes"], ["prim", "Primden kes"]].map(([v, l]) => (
              <button key={v} type="button" onClick={() => setF({ ...f, kaynak: v })} data-testid={`bulk-plan-kaynak-${v}`}
                className={`flex-1 py-2 rounded-lg text-sm font-semibold border ${f.kaynak === v ? "bg-slate-900 text-white border-slate-900" : "border-slate-300 text-slate-700"}`}>{l}</button>
            ))}
          </div>
        </div>
        <div className="p-4 border-t flex justify-end gap-2">
          <button onClick={onClose} className="px-4 py-2 rounded-lg border border-slate-200 text-sm font-semibold">İptal</button>
          <button onClick={save} disabled={busy || !(Number(f.taksit_sayisi) >= 1)} data-testid="bulk-plan-save"
            className="px-4 py-2 rounded-lg bg-slate-900 text-white text-sm font-semibold disabled:opacity-50">Uygula</button>
        </div>
      </div>
    </div>
  );
};
